import {useAppDispatch, useAppSelector} from "../../../redux/redux.hook";
import {shallowEqual} from "react-redux";
import React from "react";
import {selectAllClients, selectClientById} from "./clients.slice";
import {CreateClientData, UpdateClientInput} from "./types";
import {createClientThunk, getClientThunk, listClientsThunk, updateClientThunk} from "./clients.thunk";

export function useClients() {
    const dispatch = useAppDispatch();
    const clients = useAppSelector(selectAllClients, shallowEqual);

    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        dispatch(listClientsThunk())
            .catch(() => {
            })
            .finally(() => setLoading(false));
    }, [dispatch]);

    return {clients, loading};
}

export function useCreateClient() {
    const dispatch = useAppDispatch();
    return {createClient: (dto: CreateClientData) => dispatch(createClientThunk(dto))};
}

export function useUpdateClient() {
    const dispatch = useAppDispatch();
    return {updateClient: (id: string, dto: UpdateClientInput) => dispatch(updateClientThunk({id, dto}))};
}

export function useClient(id?: string) {
    const dispatch = useAppDispatch();

    const client = useAppSelector((state) => {
        if(id) {
            return selectClientById(state, id)
        }
    });
    const error = useAppSelector((state) => {
        if(id) {
            return   state.clients.errors[id];
        }
    });

    React.useEffect(() => {
        if (id && !client && !error) {
            dispatch(getClientThunk({id}))
        }
    }, [dispatch, error, id, client])

    return {
        client,
        error
    }
}